import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  title: string;
  description: string;
  ctaLabel?: string;
  onCta?: () => void;
}

export function EmptyState({ title, description, ctaLabel, onCta }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 size-12 rounded-full border border-border flex items-center justify-center text-text-muted">
        <Plus className="size-5" />
      </div>
      <h3 className="mb-1.5 text-md font-semibold">{title}</h3>
      <p className="mb-6 max-w-xs text-sm text-text-muted">{description}</p>
      {ctaLabel && onCta && (
        <Button onClick={onCta}>{ctaLabel}</Button>
      )}
    </div>
  );
}
